module.exports = __webpack_public_path__ + "media/images/squadBet__iconChange-2012670d8075280e4688c7b8df99d45c.png";